import { Text } from 'components';
import { theme } from 'lib';
import { useTranslation } from 'react-i18next';

const Title = ({ title, isFirst }) => {
  const { t } = useTranslation();

  return (
    <Text pad="0 16px" h2 col={isFirst ? '#000' : theme.GREY_50} marg="0 0 16px">
      {t(title)}
    </Text>
  );
};

export default Title;
